import { IInsuranceCooperationState } from 'Redux/Slices/InsuranceCooperation/InsuranceCooperationSlice';
import { Draft, PayloadAction } from '@reduxjs/toolkit';

type TUserPayload = { name?: string; email: string; insuranceNumber?: string; [key: string]: unknown };

export const persistHealthInsuranceUserData = (state: Draft<IInsuranceCooperationState>, { payload }: PayloadAction<TUserPayload>) => {
  state.form = { ...(state.form || {}), user: payload };
  state.updatedAt = Date.now();
};
